
import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { Role, Roles } from '../models/roles';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  // Local role definitions
  private readonly localRoles: Role[] = [
    { id: Roles.SystemAdministrator, name: 'Sistemski administrator' },
    { id: Roles.AssociationResponsiblePerson, name: 'Odgovorna osoba u udruzi' },
    { id: Roles.MunicipalityAdministrator, name: 'Administrator u Općini' }
  ];

  constructor() {}

  getRoles(): Observable<Role[]> {
    // Simulate HTTP call using a Promise
    const promise = new Promise<Role[]>((resolve) => {
      // You can add a small delay if you want to simulate a network request
      setTimeout(() => {
        resolve(this.localRoles);
      }, 300);
    });

    // Convert the Promise to an Observable
    return from(promise);
  }

//   getAllRoles(): Observable<Role[]> {
//     return this.http.get<Role[]>('/roles');
//   }
}
